import * as actionTypes from './actionTypes';
import axios from 'axios'

export const signInStart = () =>{
  return {
    type: actionTypes.SIGN_IN_START
  }
}

export const signInSuccess = (idToken, userId) =>{
  return {
    type: actionTypes.SIGN_IN_SUCCESS,
    idToken: idToken,
    userId: userId
  }
}

export const signInFail = (error) =>{
  return {
    type: actionTypes.SIGN_IN_FAIL,
    error: error
  }
}

export const signInHandler = (email, password, isSignUp) =>{
  return dispatch =>{
    dispatch(signInStart())
    const authData = {
      email: email, password: password, returnSecureToken: true
      }
    
    let url = 'https://identitytoolkit.googleapis.com/v1/accounts';
    const signIn = `:signInWithPassword?key=${process.env.REACT_APP_API_KEY}`;
    const signUp = `:signUp?key=${process.env.REACT_APP_API_KEY}`;


    if(isSignUp) url += signUp;
    else url += signIn;

    axios.post( url , authData)
        .then(response  => { 

          let expirationDate = new Date(new Date().getTime() + response.data.expiresIn*1000);
          localStorage.setItem('token', response.data.idToken);
          localStorage.setItem('expirationDate', expirationDate );
          localStorage.setItem('userId', response.data.localId);

          dispatch(signInSuccess(response.data.idToken, response.data.localId));
          dispatch(logOutHandler(response.data.expiresIn))
        })
        .catch(error =>{
          console.log(error)
          dispatch(signInFail(error.response.data.error));
        })
  }
}

export const logOutHandler = (time) =>{
  return dispatch =>{
    setTimeout(() =>  dispatch(logout()), time*1000 ) 
  }
}

export const logout = () =>{
  localStorage.removeItem('token');
  localStorage.removeItem('expirationDate');
  localStorage.removeItem('userId');

  return {
    type: actionTypes.AUTH_LOGOUT
  }
}

export const authRedirect = (path) =>{
  return {
    type: actionTypes.AUTH_REDIRECT,
    path: path
  }
}

export const autoSignIn = () =>{
  return dispatch =>{
    let token = localStorage.getItem('token');

    if(!token){

      dispatch(logout())

    }else{
      let expirationDate = new Date(localStorage.getItem('expirationDate'));
      let userId = localStorage.getItem('userId');

      if(expirationDate <= new Date()){

        dispatch(logout())

      }else{
        dispatch(signInSuccess(token, userId));
        dispatch(logOutHandler((expirationDate.getTime() - new Date().getTime())/1000))
      }
      

    }
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/auth.js